// @ts-strict-ignore
import { Typography } from '@mui/material'
import React from 'react'
import { usePageHeaderContext } from 'components/PageHeader/PageHeaderContext'
import useStyles from './styles'

export interface IPageHeaderTitleProps extends React.HTMLProps<HTMLDivElement> {
  variant?: 'center' | 'default'
}

const PageHeaderTitle: React.FC<IPageHeaderTitleProps> = (props) => {
  const { alternativeHeader } = usePageHeaderContext()
  const { classes } = useStyles()
  const { children, className, variant, ...other } = props

  const getClassName = (cn: string, vr: string, ah: boolean): string => {
    const classList = [classes.headerTitle]

    if (cn) {
      classList.push(cn)
    }

    if (vr === 'center') {
      classList.push(classes.center)
    }

    if (!ah) {
      classList.push(classes.defaultTheme)
    }

    return classList.join(' ')
  }

  return (
    <div className={getClassName(className, variant, alternativeHeader)} {...other}>
      <Typography variant="h1" component="div">
        {children}
      </Typography>
    </div>
  )
}

export default PageHeaderTitle
